module.exports = __webpack_public_path__ + "fonts/3MCircularTT-BoldItalic.883fe05c.woff";